import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthService } from "../../../Axios/authService";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
// import { checkFilter } from "../../../Common/filterUtils";

export const login = createAsyncThunk(
    'auth/login',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthService.login(data.email, data.password);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);